// src/services/userService.ts
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://lavernaibackend.onrender.com/api';

const completeOnboarding = async () => {
  // Get the token from localStorage
  const token = localStorage.getItem("authToken");
  if (!token) {
    throw new Error("No auth token found.");
  }
  
  // Include the token in the Authorization header
  const response = await axios.put(
    `${API_URL}/users/complete-onboarding`,
    {}, // no request body
    {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
    }
  );
  return response.data.data.user;
};

export default {
  completeOnboarding,
};
